import { render, staticRenderFns } from "./ArchiveIcon.vue?vue&type=template&id=bfff9c48&"
import script from "./ArchiveIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ArchiveIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports